import SolicitarInfoImc from './SolicitarInfoImc';

export default SolicitarInfoImc;
